import { FC, PropsWithChildren } from 'react';
import BlankLayoutWithSidebar from '@/layouts/BlankLayoutWithSidebar';

const LessonsLayout: FC<PropsWithChildren> = ({ children }) => {
  return <BlankLayoutWithSidebar>{children}</BlankLayoutWithSidebar>;
};

export default LessonsLayout;
